export const SURVEYSCORE_LOADING = "SURVEYSCORE_LOADING";
export const SURVEYSCORE_RESET = "SURVEYSCORE_RESET";
export const GET_SURVEYSCORE = "GET_SURVEYSCORE";
export const GET_SURVEYSCORE_SUCCESS = "GET_SURVEYSCORE_SUCCESS";
export const GET_SURVEYSCORE_FAIL = "GET_SURVEYSCORE_FAIL";
export const DELETE_SURVEYSCORE = "DELETE_SURVEYSCORE";
export const DELETE_SURVEYSCORE_SUCCESS = "DELETE_SURVEYSCORE_SUCCESS";
export const DELETE_SURVEYSCORE_FAIL = "DELETE_SURVEYSCORE_FAIL";
export const UPDATE_SURVEYSCORE = "UPDATE_SURVEYSCORE";
export const UPDATE_SURVEYSCORE_SUCCESS = "UPDATE_SURVEYSCORE_SUCCESS";
export const UPDATE_SURVEYSCORE_FAIL = "UPDATE_SURVEYSCORE_FAIL";
export const ADD_NEW_SURVEYSCORE = "ADD_NEW_SURVEYSCORE";
export const ADD_SURVEYSCORE_SUCCESS = "ADD_SURVEYSCORE_SUCCESS";
export const ADD_SURVEYSCORE_FAIL = "ADD_SURVEYSCORE_FAIL";
export const SURVEYSCORE_RESET_CREATE = "SURVEYSCORE_RESET_CREATE";
